import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

import { userRanking, useGame, useUser } from 'data/hooks'

export const useRankingData = (gameId, rankingId, eventId, instanceId) => {

  const dispatch = useDispatch()
  const { userId } = useUser()
  const { kpis } = useGame(gameId)
  // const { ranking } = useRanking(gameId, rankingId, eventId)

  const game = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}) )
  const event = (game?.events || {})[eventId]
  const ranking = event && event.rankings ? event.rankings[rankingId] : undefined

  useEffect(() => {

    if (!gameId || !rankingId || !eventId) return
    if (ranking?.list) return
    // refresh()

  }, [ranking, rankingId, eventId])


  const refresh = () => {

    // if (!ranking) return
    dispatch(actions.rankingDataLoad(userId, gameId, eventId, rankingId, instanceId))
  }

  return {
    list: ranking?.list,
    after: ranking?.after,
    me: ranking?.me,
    before: ranking?.before,
    ties: ranking?.ties,
    refresh
  }
}
